import { Column } from '@components/dnd/base/blockBase/body.block.style';

import type { DataSourceOption, SourcesData } from '@stratumn/studio-shared';

import { RenderSource } from '../sourceSelector/renderSource';
import { SourceSelector } from '../sourceSelector/sourceSelector';

type Props = {
  id: string;
  dataSource: DataSourceOption;
  onDataSourceChange: (source: DataSourceOption) => void;

  sourcesData: SourcesData;
  onSourceDataChange: (sourceData: SourcesData) => void;
  possibleSources?: DataSourceOption[];
};

export const DataSelector = (props: Props) => (
  <>
    <Column>
      <SourceSelector
        dataSource={props.dataSource}
        id={props.id}
        onDataSourceChange={props.onDataSourceChange}
        possibleSources={props.possibleSources}
      />
    </Column>
    <Column $width="220px">
      <RenderSource
        id={props.id}
        onSourceDataChange={props.onSourceDataChange}
        selectedDataSource={props.dataSource}
        sourcesData={props.sourcesData}
      />
    </Column>
  </>
);
